import React from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const Rsvp = ({ rsvpType }) => {
  const hasEventsMandatory = useFeatureFlags(['learning_events_mandatory']);
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          {hasEventsMandatory
            ? t('in_person_training.event_overview.attendance_type.title')
            : t('in_person_training.event_overview.rsvp.title')}
        </span>
      </SectionHeader>
      {!hasEventsMandatory && (
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
          {rsvpType === 'single'
            ? t('in_person_training.event_overview.rsvp.single.description')
            : t('in_person_training.event_overview.rsvp.all.description')}
        </Text>
      )}
      {hasEventsMandatory && (
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="mb-4">
          {rsvpType === 'single'
            ? t('in_person_training.event_overview.attendance_type.rsvp_single')
            : t('in_person_training.event_overview.attendance_type.rsvp_all')}
        </Text>
      )}
    </Section>
  );
};

export default Rsvp;
